import { render, staticRenderFns } from "./vFormWEBSITE.vue?vue&type=template&id=156928dc&scoped=true&"
import script from "./vFormWEBSITE.vue?vue&type=script&lang=js&"
export * from "./vFormWEBSITE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156928dc",
  null
  
)

export default component.exports